export default {
  state: {
    // location: '',
    latitude: 0,
    longitude: 0,
  },
  mutations: {
    // setLocation(state,payload) {
    //   state.location = payload
    // },
    setLatitude(state,payload) {
      state.latitude = payload
    },
    setLongitude(state,payload) {
      state.longitude = payload
    }
  }
}